import styled from 'styled-components'

export const TopicsDetailListContainer = styled.ul`
  padding-left: 12px;
  list-style: none;
  width: 100%;
  margin-top: 0;
  li:first-child h2 {
    margin-top: 0;
  }
`
